var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendemoji2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4834 61.9553C23.9788 58.3088 24.5384 58.0847 26.8327 56.538C27.8631 55.8435 29.6852 54.6553 31.1045 53.8682C34.2862 52.1033 38.2739 50.949 42.3717 50.7095C62.1388 49.5541 72.9258 69.2149 57.5138 59.057C39.8928 47.4432 30.5478 62.6118 24.4834 61.9553ZM57.0087 27.8059C63.4068 24.1713 66.9676 34.7096 61.2042 37.0936C55.114 39.6122 50.5808 31.4572 57.0087 27.8059ZM27.0156 27.8901C34.0917 24.6583 36.8274 34.2207 31.7389 36.8807C28.4111 38.6206 25.3032 36.7959 24.3402 34.2949C22.968 30.7309 24.9242 28.845 27.0156 27.8901ZM0.0773609 47.2785C1.38296 70.4316 22.0252 89.9529 46.9309 88.2941C70.4157 86.7296 89.9524 66.6489 88.2093 41.0875C86.6109 17.6447 66.1572 -1.77485 40.7063 0.128654C17.3789 1.87335 -1.35844 21.8191 0.0773609 47.2785Z",
    fill: "#F2B51E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendemoji2);
export default __webpack_public_path__ + "static/media/friendemoji2.8f606b3041b836fd71380368d9bd82e1.svg";
export { ForwardRef as ReactComponent };